import axios from 'axios';
import { API } from '../../constants';
import _ from 'lodash';
import { push as PushRouter } from 'connected-react-router';

const createAction = name => ({
    ORDER_FILTER_CHANGE: `${name}_ORDER_FILTER_CHANGE`,
    GET_PURCHASE_ORDER_BY_USER_ID_PENDING: `${name}_GET_PURCHASE_ORDER_BY_USER_ID_PENDING`,
    GET_PURCHASE_ORDER_BY_USER_ID_SUCCESS: `${name}_GET_PURCHASE_ORDER_BY_USER_ID_SUCCESS`,
    GET_PURCHASE_ORDER_BY_USER_ID_FAILED: `${name}_GET_PURCHASE_ORDER_BY_USER_ID_FAILED`,

    GET_PURCHASE_ORDER_BY_ORDER_ID_PENDING: `${name}_GET_PURCHASE_ORDER_BY_ORDER_ID_PENDING`,
    GET_PURCHASE_ORDER_BY_ORDER_ID_SUCCESS: `${name}_GET_PURCHASE_ORDER_BY_ORDER_ID_SUCCESS`,
    GET_PURCHASE_ORDER_BY_ORDER_ID_FAILED: `${name}_GET_PURCHASE_ORDER_BY_ORDER_ID_FAILED`,

    REFUND_FILTER_CHANGE: `${name}_REFUND_FILTER_CHANGE`,
    GET_REFUND_BY_CUSTOMER_ID_PENDING: `${name}GET_REFUND_BY_CUSTOMER_ID_PENDING`,
    GET_REFUND_BY_CUSTOMER_ID_SUCCESS: `${name}GET_REFUND_BY_CUSTOMER_ID_SUCCESS`,
    GET_REFUND_BY_CUSTOMER_ID_FAILED: `${name}GET_REFUND_BY_CUSTOMER_ID_FAILED`,

    SUBMIT_RETURN_FORM_DATA_PENDING: `${name}_SUBMIT_RETURN_FORM_DATA_PENDING`,
    SUBMIT_RETURN_FORM_DATA_SUCCESS: `${name}_SUBMIT_RETURN_FORM_DATA_SUCCESS`,
    SUBMIT_RETURN_FORM_DATA_FAILED: `${name}_SUBMIT_RETURN_FORM_DATA_FAILED`,

    OPEN_DIALOG_NOT_SELECT: `${name}_OPEN_DIALOG_NOT_SELECT`,
    CLOSE_DIALOG_NOT_SELECT: `${name}_CLOSE_DIALOG_NOT_SELECT`,

    OPEN_DIALOG_OVER_MAX_FILES: `${name}_OPEN_DIALOG_OVER_MAX_FILES`,
    CLOSE_DIALOG_OVER_MAX_FILES: `${name}_CLOSE_DIALOG_OVER_MAX_FILES`,

    OPEN_DIALOG_SELECT_REMARK: `${name}_OPEN_DIALOG_SELECT_REMARK`,
    CLOSE_DIALOG_SELECT_REMARK: `${name}_CLOSE_DIALOG_SELECT_REMARK`,

    OPEN_DIALOG_FILE_TYPE_NOT_SUPPORT: `${name}_OPEN_DIALOG_FILE_TYPE_NOT_SUPPORT`,
    CLOSE_DIALOG_FILE_TYPE_NOT_SUPPORT: `${name}_CLOSE_DIALOG_FILE_TYPE_NOT_SUPPORT`,

    OPEN_DIALOG_FILE_REQUIRED: `${name}_OPEN_DIALOG_FILE_REQUIRED`,
    CLOSE_DIALOG_FILE_REQUIRED: `${name}_CLOSE_DIALOG_FILE_REQUIRED`,

    OPEN_DIALOG_SUBMIT_ERROR: `${name}_OPEN_DIALOG_SUBMIT_ERROR`,
    CLOSE_DIALOG_SUBMIT_ERROR: `${name}_CLOSE_DIALOG_SUBMIT_ERROR`,

    GET_VOUCHER_BY_USER_ID_PENDING: `${name}_GET_VOUCHER_BY_USER_ID_PENDING`,
    GET_VOUCHER_BY_USER_ID_SUCCESS: `${name}_GET_VOUCHER_BY_USER_ID_SUCCESS`,
    GET_VOUCHER_BY_USER_ID_FAILED: `${name}_GET_VOUCHER_BY_USER_ID_FAILED`,
    VOUCHER_ORDER_FILTER_CHANGE: `${name}_VOUCHER_ORDER_FILTER_CHANGE`,

    GET_PURCHASE_ORDER_BY_INVOICE_PENDING: `${name}_GET_PURCHASE_ORDER_BY_INVOICE_PENDING`,
    GET_PURCHASE_ORDER_BY_INVOICE_SUCCESS: `${name}_GET_PURCHASE_ORDER_BY_INVOICE_SUCCESS`,
    GET_PURCHASE_ORDER_BY_INVOICE_FAILED: `${name}_GET_PURCHASE_ORDER_BY_INVOICE_FAILED`,
    
    GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_PENDING: `${name}_GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_PENDING`,
    GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_SUCCESS: `${name}_GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_SUCCESS`,
    GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_FAILED: `${name}_GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_FAILED`
});

export const USER = createAction('USER');

export const UserOrderFilterChange = value => dispatch => {
    dispatch({
        type: USER.ORDER_FILTER_CHANGE,
        payload: value
    });
};

export const UserGetPurchaseOrderByUserId = () => async (dispatch, getState) => {
    dispatch({ type: USER.GET_PURCHASE_ORDER_BY_USER_ID_PENDING });
    try {
        const { login, language } = getState();
        const params = { customerId: login.firebaseAuth.uid };

        const result = await axios
            .get(
                API.GET_PURCHASE_ORDER_BY_CUSTOMER_ID,
                {
                    params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                }
            )
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_USER_ID_SUCCESS,
            payload: result.map(item => item.status === "PRINTED" ? { ...item, status: "PENDING" } : { ...item })
        });
    } catch (error) {
        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_USER_ID_FAILED,
            error
        });
    }
};

export const UserGetPurchaseOrderByOrderId = orderId => async (dispatch, getState) => {
    dispatch({ type: USER.GET_PURCHASE_ORDER_BY_ORDER_ID_PENDING });
    try {
        const { currentLanguage } = getState().language;
        const result = await axios
            .get(`${API.GET_PURCHASE_ORDER_BY_ORDER_ID}?id=${orderId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        let modOrderDetail = [];
        result.orderDetail.forEach(list => {
            modOrderDetail = [...modOrderDetail, { ...list, remark: 'default' }];
        });

        result.orderDetail = modOrderDetail;

        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_ORDER_ID_SUCCESS,
            payload: result
        });
    } catch (error) {
        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_ORDER_ID_FAILED,
            error
        });
    }
};

export const UserRefundFilterChange = value => dispatch => {
    dispatch({
        type: USER.REFUND_FILTER_CHANGE,
        payload: value
    });
};

export const GetRefundByCustomerId = () => async (dispatch, getState) => {
    dispatch({ type: USER.GET_REFUND_BY_CUSTOMER_ID_PENDING });
    try {
        const { login, language } = getState();
        const { currentLanguage } = language;

        const result = await axios
            .get(`${API.GET_REFUND_ITEMS_BY_CUSTOMER_ID}?id=${login.firebaseAuth.uid}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: USER.GET_REFUND_BY_CUSTOMER_ID_SUCCESS,
            payload: result
        });
    } catch (error) {
        dispatch({
            type: USER.GET_REFUND_BY_CUSTOMER_ID_FAILED,
            error
        });
    }
};

export const UserSubmitReturnFormData = (makeReturnData, filterReturnOrder, previewImages, details) => async (
    dispatch,
    getState
) => {
    dispatch({ type: USER.SUBMIT_RETURN_FORM_DATA_PENDING });
    try {
        const { login, language } = getState();
        const { currentLanguage } = language;
        makeReturnData.orderDetail = filterReturnOrder;
        const params = {
            orderId: makeReturnData.orderId,
            details: details,
            customerId: login.firebaseAuth.uid,
            itemOrderRefund: JSON.stringify(makeReturnData.orderDetail)
        };

        var formdata = new FormData();
        previewImages.forEach(file => formdata.append("images", file.file));
        for (const [prop, value] of Object.entries(params)) formdata.append(prop, value);

        const result = await axios
            .post(API.CREATE_REFUND_ITEM, formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept-Language': currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: USER.SUBMIT_RETURN_FORM_DATA_SUCCESS,
            payload: result
        });
        dispatch(PushRouter('/user/return'));
    } catch (error) {
        dispatch({
            type: USER.SUBMIT_RETURN_FORM_DATA_FAILED,
            error
        });
        dispatch(UserOpenDialogSubmitError());
    }
};

export const GetVoucherByCustomerId = () => async (dispatch, getState) => {
    dispatch({ type: USER.GET_VOUCHER_BY_USER_ID_PENDING });
    try {

        const { login, language } = getState();
        const result = await axios.get(`${API.GET_VOUCHER}?customerId=${login.firebaseAuth.uid}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': language.currentLanguage
            }
        })
            .then(res => res.data)
            .catch(err => Promise.reject(err));

        dispatch({
            type: USER.GET_VOUCHER_BY_USER_ID_SUCCESS,
            payload: result
        })

    } catch (error) {
        dispatch({
            type: USER.GET_VOUCHER_BY_USER_ID_FAILED,
            payload: error
        });
    }
}

export const UserGetPurchaseOrderByInvoice = invoice => async (dispatch, getState) => {
    dispatch({ type: USER.GET_PURCHASE_ORDER_BY_INVOICE_PENDING });
    try {
        const { login, language } = getState();
        const params = { customerId: login.firebaseAuth.uid, invoice };

        const result = await axios
            .get(
                API.GET_PURCHASE_ORDER_BY_INVOICE,
                { 
                    params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                }
            )
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_INVOICE_SUCCESS,
            payload: [{ ...result, status: result.status === "PRINTED" ? "PENDING" : result.status }]
        });
    } catch (error) {
        dispatch({
            type: USER.GET_PURCHASE_ORDER_BY_INVOICE_FAILED,
            error
        });
    }
};

export const UserGetPurchaseOrderOfGuestByInvoice = (params) => async (dispatch, getState) => {
    dispatch({ type: USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_PENDING });
    try {
        const { language } = getState();

        const result = await axios
            .get(
                API.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE,
                { 
                    params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                }
            )
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_SUCCESS,
            payload: [{ ...result, status: result.status === "PRINTED" ? "PENDING" : result.status }]
        });
    } catch (error) {
        dispatch({
            type: USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_FAILED,
            error
        });
    }
};

export const UserOpenDialogNotSelect = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_NOT_SELECT });
};

export const UserCloseDialogNotSelect = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_NOT_SELECT });
};

export const UserOpenDialogOverMaxFiles = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_OVER_MAX_FILES });
};

export const UserCloseDialogOverMaxFiles = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_OVER_MAX_FILES });
};

export const UserOpenDialogSelectRemark = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_SELECT_REMARK });
};

export const UserCloseDialogSelectRemark = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_SELECT_REMARK });
};

export const UserOpenDialogFileTypeNotSupport = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_FILE_TYPE_NOT_SUPPORT });
};

export const UserCloseDialogFileTypeNotSupport = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_FILE_TYPE_NOT_SUPPORT });
};

export const UserOpenDialogFileRequired = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_FILE_REQUIRED });
};

export const UserCloseDialogFileRequired = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_FILE_REQUIRED });
};

export const UserOpenDialogSubmitError = () => dispatch => {
    dispatch({ type: USER.OPEN_DIALOG_SUBMIT_ERROR });
};

export const UserCloseDialogSubmitError = () => dispatch => {
    dispatch({ type: USER.CLOSE_DIALOG_SUBMIT_ERROR });
};

export const UserVoucherOrderFilterChange = value => dispatch => {
    dispatch({
        type: USER.VOUCHER_ORDER_FILTER_CHANGE,
        payload: value
    })
}